import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

export const fetchAuditLogs = createAsyncThunk('auditLogs/fetchAuditLogs', async () => {
  try {
    const token = Cookies.get('token');
    const response = await fetch(process.env.REACT_APP_BASE_URL + 'audit-logs', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const fetchAuditLogsPaginated = createAsyncThunk(
  'auditLogs/fetchAuditLogsPaginated', 
  async (params = {}) => {
    try {
      const token = Cookies.get('token');
      
      // Build query parameters
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.take) queryParams.append('take', params.take);
      if (params.model) queryParams.append('model', params.model);
      if (params.fromDate) queryParams.append('fromDate', params.fromDate);
      if (params.toDate) queryParams.append('toDate', params.toDate);
      if (params.keyword) queryParams.append('keyword', params.keyword);
      
      const queryString = queryParams.toString();
      const url = process.env.REACT_APP_BASE_URL + 'audit-logs' + (queryString ? `?${queryString}` : '');
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching paginated audit logs:', error);
      throw error;
    }
  }
);

export const fetchAuditLog = createAsyncThunk('auditlogs/fetchAuditLog', async (model) => {
  try {
    const token = Cookies.get('token');
    const response = await fetch(process.env.REACT_APP_BASE_URL + `audit-logs/${model}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

const auditLogsSlice = createSlice({
  name: 'auditLogs',
  initialState: {
    auditLogs: [],
    paginatedData: {
      data: [],
      meta: {
        page: 1,
        limit: 50,
        total: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPrevPage: false,
      },
    },
    isLoading: false,
    isPaginationLoading: false,
    error: null,
  },
  reducers: {
    removeAuditLogs: (state) => {
      state.auditLogs = null;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAuditLogs.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAuditLogs.fulfilled, (state, action) => {
      state.isLoading = false;
      state.auditLogs = action.payload;
      state.error = null;
    });
    builder.addCase(fetchAuditLogs.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    // Paginated audit logs
    builder.addCase(fetchAuditLogsPaginated.pending, (state) => {
      state.isPaginationLoading = true;
      state.error = null;
    });
    builder.addCase(fetchAuditLogsPaginated.fulfilled, (state, action) => {
      state.isPaginationLoading = false;
      state.paginatedData = action.payload;
      state.error = null;
    });
    builder.addCase(fetchAuditLogsPaginated.rejected, (state, action) => {
      state.isPaginationLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { removeAuditLogs } = auditLogsSlice.actions;

export default auditLogsSlice.reducer;

export const selectAuditLogs = (state) => state.auditLogs.auditLogs;
export const selectPaginatedAuditLogs = (state) => state.auditLogs.paginatedData;
export const selectAuditLogsLoading = (state) => state.auditLogs.isPaginationLoading;
